// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {

  envName: 'dev',
  BASE_API_URL: 'https://vice.dev.consilium.europa.eu/',

  viceNewRestAPI: 'https://vice.dev.consilium.europa.eu',
  viceNewRestAPISecret: 'HJ2n7qx5BoYt1MuYCxkL9Y0E1ThXdR2Yg8G3bxmJK8',
  viceNewGraphQlAPI: 'https://api-challengeu.dev.consilium.europa.eu/graphql/',

  defaultLanguage: 'en-GB',
  cookiesTimerKey: '@cookies_timer',
  cookiesExpiryDurationInMonths: 2
};
